// extracted by mini-css-extract-plugin
export default {"wrapper":"launcher_wrapper__0ylSD","button":"launcher_button__Qzn1G","modal":"launcher_modal__NbD6W"};